import {TicketStatus as TicketStatusVo} from '../../common/shared/api/nicolas/vo/enums/TicketStatus.enum';
import {TicketStatus} from '../generated/types';

export function createTicketStatus(
  ticketStatus: TicketStatusVo
): TicketStatus | undefined {
  if (!ticketStatus) {
    return undefined;
  }
  return map[ticketStatus];
}

const map: {[key in TicketStatusVo]: TicketStatus} = {
  [TicketStatusVo.NONE]: TicketStatus.None,
  [TicketStatusVo.TS01]: TicketStatus.Ts01,
  [TicketStatusVo.TS02]: TicketStatus.Ts02,
  [TicketStatusVo.TS03]: TicketStatus.Ts03,
};
